import React, { useState } from 'react';
import Modal from '../../../componentes/Modal';
import CustomSelect from '../../../componentes/shared/CustomSelect';

const AddItemButton = ({ onAddItem, disabled, unidadOptions = [], igvOptions = [] }) => {
    const [showModal, setShowModal] = useState(false);
    const [newItem, setNewItem] = useState({
        descripcion: '',
        cantidad: 1,
        unidad: 'ZZ',
        igv: '10',
        pVenta: 0,
        descuento: 0,
        has_icbper: false
    });

    const handleOpenModal = () => {
        setNewItem({
            descripcion: '',
            cantidad: 1,
            unidad: unidadOptions.length > 0 ? (unidadOptions.find(u => u.id === 'ZZ') ? 'ZZ' : unidadOptions[0].id) : 'ZZ',
            igv: igvOptions.length > 0 ? (igvOptions.find(o => o.id === '10') ? '10' : igvOptions[0].id) : '10',
            pVenta: 0,
            descuento: 0,
            has_icbper: false
        });
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleChange = (field, value) => {
        setNewItem(prev => ({ ...prev, [field]: value }));
    };

    const handleAdd = () => {
        if (!newItem.descripcion.trim()) {
            alert('Por favor ingrese una descripción');
            return;
        }
        onAddItem({
            ...newItem,
            cantidad: parseFloat(newItem.cantidad || 0),
            pVenta: parseFloat(newItem.pVenta || 0),
            descuento: parseFloat(newItem.descuento || 0)
        });
        setShowModal(false);
    };

    return (
        <>
            <button className="btn-teal px-4" onClick={handleOpenModal} disabled={disabled}>
                Agr. Item
            </button>

            <Modal isOpen={showModal} onClose={handleCloseModal} title="Agregar Item" className="modal-lg">
                <div className="p-3">
                    <div className="form-group-custom">
                        <label>Detalle:</label>
                        <textarea 
                            className="form-input-custom" 
                            rows="3"
                            value={newItem.descripcion}
                            onChange={(e) => handleChange('descripcion', e.target.value)}
                        ></textarea>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group-custom">
                                <label>Cantidad:</label>
                                <input 
                                    type="number" 
                                    className="form-input-custom" 
                                    value={newItem.cantidad}
                                    onChange={(e) => handleChange('cantidad', e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group-custom">
                                <label>Precio:</label>
                                <input 
                                    type="number" 
                                    className="form-input-custom" 
                                    value={newItem.pVenta}
                                    onChange={(e) => handleChange('pVenta', e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group-custom">
                                <label>Descuento:</label>
                                <input 
                                    type="number" 
                                    className="form-input-custom" 
                                    value={newItem.descuento}
                                    onChange={(e) => handleChange('descuento', e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group-custom">
                                <label>Unidad de medida:</label>
                                <CustomSelect 
                                    options={unidadOptions}
                                    label="nombre"
                                    value="id"
                                    initialValue={newItem.unidad}
                                    onSelect={(opt) => handleChange('unidad', opt.id)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group-custom">
                                <label>IGV:</label>
                                <CustomSelect 
                                    options={igvOptions}
                                    label="nombre"
                                    value="id"
                                    initialValue={newItem.igv}
                                    onSelect={(opt) => handleChange('igv', opt.id)}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 d-flex align-items-center">
                            <div className="form-check">
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="has_icbper"
                                    checked={newItem.has_icbper}
                                    onChange={(e) => handleChange('has_icbper', e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="has_icbper">
                                    Impuesto bolsas (ICBPER)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                        <button className="btn btn-secondary mr-2" onClick={handleCloseModal}>Cancelar</button>
                        <button className="btn-teal" onClick={handleAdd}>Agregar</button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AddItemButton;